module.exports = __webpack_public_path__ + "static/img/castrol-edge.eb14252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/castrol-edge.png
// module id = FWnP
// module chunks = 1